import { useState } from "react";

import EditorFrame, { BgEditButton } from "@/components/editors/EditorFrame";
import BackgroundEditor from "@/components/editors/parts-editors/BackgroundEditor";
import { SliderEditor } from "@/components/editors/parts-editors/slider/SliderEditor";
import { EditorModalProps } from "@/hooks/useTemplatePartsEditor";
import { SliderTypeTemplate as ISlider } from "@/states/page-editor/template-parts/slider";

interface Props {
  part: ISlider;
  handleChange: (updated: ISlider) => void;
  handleDelete?: () => void;
  setEditorModalPrpps: (props: EditorModalProps) => void;
}

export default function SliderTemplate({
  part,
  handleChange,
  handleDelete,
  setEditorModalPrpps,
}: Props) {
  const [isEditingBgEditor, setIsEditingBgEditor] = useState(false);

  const handleSubmit = (slider: ISlider) => {
    handleChange(slider);
  };

  return (
    <div
      className={`mx-[-16px] px-0 md:mx-[calc((-100vw+256px+920px)/2)] md:px-[calc((100vw-256px-920px)/2)]`}
      style={part.bgCssProperties}
    >
      <EditorFrame
        editButton={<BgEditButton onClick={() => setIsEditingBgEditor(true)} />}
        handleClose={handleDelete}
      >
        <SliderEditor
          slider={part}
          handleSubmit={handleSubmit}
          setEditorModalPrpps={setEditorModalPrpps}
          isPreviewImage
        />

        <BackgroundEditor
          show={isEditingBgEditor}
          backgroundStyle={part.bgCssProperties}
          onClose={() => setIsEditingBgEditor(false)}
          onChange={(bgCss) =>
            handleChange({
              ...part,
              bgCssProperties: bgCss,
            })
          }
        />
      </EditorFrame>
    </div>
  );
}
